class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    if (this.isOpen()) return;
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    this.isHeaderSearch = !!this.closest('.section-header') && !!this.querySelector('.search-modal');
    if (this.isHeaderSearch) {
      document.documentElement.classList.add('sembonia-search-open');
    }
    window.semboniaScrollLock.acquire(this);
    this.detailsContainer.setAttribute('data-lenis-prevent', '');

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    if (!this.isOpen()) return;
    removeTrapFocus();
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    if (this.isHeaderSearch) {
      document.documentElement.classList.remove('sembonia-search-open');
      this.isHeaderSearch = false;
    }
    window.semboniaScrollLock.release(this);
    this.detailsContainer.removeAttribute('data-lenis-prevent');
    if (focusToggle && !window.semboniaScrollLock.size && this.summaryToggle.isConnected) this.summaryToggle.focus({preventScroll:true});
  }
  disconnectedCallback() {
    document.body.removeEventListener('click', this.onBodyClickEvent);
    if (this.isOpen()) this.close(false);
    window.semboniaScrollLock.release(this);
  }
}

customElements.define('details-modal', DetailsModal);
